import "./Services.css";

import ServiceCard from "./ServiceCard";

import progLX from "../../images/ServicePhotos/progLX.webp";
import progVid from "../../images/ServicePhotos/progVid.webp";
import tcPbk from "../../images/ServicePhotos/tc-pbk.webp";
import laserWeb from "../../images/ServicePhotos/laser_web.webp";
import showOp from "../../images/ServicePhotos/show_op.webp";
import renders from "../../images/ServicePhotos/renders.webp";
import paperwork from "../../images/ServicePhotos/paperwork.webp";
import design from "../../images/ServicePhotos/design.webp";
import tech from "../../images/ServicePhotos/tech.webp";

const services = [
  {
    service: "Festival, Tour, &",
    service2: "Stage Design",
    photo: design,
    alt: "Festival stage design",
  },
  {
    service: "Vectorworks, Plots, &",
    service2: "Technical Paperwork",
    photo: paperwork,
    alt: "Technical paperwork and plots",
  },
  {
    service: "Stage Concepts",
    service2: "& Renders",
    photo: renders,
    alt: "Stage concept renders",
  },
  {
    service: "Lighting",
    service2: "Programming",
    photo: progLX,
    alt: "Lighting programming",
    isLogo: true,
  },
  {
    service: "Laser",
    service2: "Programming",
    photo: laserWeb,
    alt: "Laser programming",
  },
  {
    service: "Video",
    service2: "Programming",
    photo: progVid,
    alt: "Video programming",
    isLogo: true,
  },
  {
    service: "Technical",
    service2: "Direction",
    photo: tech,
    alt: "Technical direction",
    isLogo: true,
  },
  {
    service: "Show",
    service2: "Operation",
    photo: showOp,
    alt: "Show operation",
  },
  {
    service: "Timecode &",
    service2: "Playback Systems",
    photo: tcPbk,
    alt: "Timecode and playback systems",
    isLogo: true,
  },
];

function Services() {
  return (
    <section id="services" className="services-section snap-section">
      <div className="services-inner">
        <header className="services-header">
          <h2 className="text-2xl font-extrabold leading-tight md:text-3xl 2xl:text-4xl">
            Here's what
          </h2>
          <h2 className="text-xl font-bold leading-tight text-rld-muted md:text-2xl 2xl:text-3xl">
            we can do for you.
          </h2>
        </header>

        <div className="services-grid">
          {services.map((item) => (
            <ServiceCard
              key={`${item.service}-${item.service2}`}
              service={item.service}
              service2={item.service2}
              photo={item.photo}
              alt_info={item.alt}
              isLogo={item.isLogo}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
